/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 홍보결과 목록 컴포넌트
 * 버전 : 1.0
 * 파일명 : PromoResultsPage.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2025-07-16, 강동형 : 저작권 추가, 기획 변경에 따른 레이아웃 및 스타일 변경
 *================================================================
 */

import { useState, useEffect } from 'react'
import InputBoxSearch from 'src/components/inputbox/InputBoxSearch'
import { styled } from '@mui/material'
import { useDialogStore } from 'src/stores/DialogStore';
import PromoResultDialog from 'src/components/promoResult/PromoResultDialog';
import PromoResults from 'src/components/promoResult/PromoReults';
import { NextButton } from 'src/components/common/CommonStyled';
import PromoResultAdd from 'src/components/promoResult/PromoResultAdd';
import { useBackHandlerStore, useNavbarStore } from 'src/stores/UIStore';
import PromoResultModify from 'src/components/promoResult/PromoResultModify';
import { usePromoresultStore } from 'src/stores/PromoStore';
import PromoResultDetail from 'src/components/promoResult/PromoResultDetail';
import InterestedAdd from 'src/components/promoResult/PromoInterestedAdd';
import PromoInterstedModify from 'src/components/promoResult/PromoInterstedModify';
import { submitPromoFilter } from 'src/components/promoResult/useSubmitPromoFilter';
import FilterBar from 'src/components/promoResult/FilterBar';

const SearchContainer = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: '10px',

    padding: '10px',
    width:'100%',
    zIndex:2,
    backgroundColor:'white',
    borderBottom:'1px solid #DDDDDD'
    });

const SearchBox = styled('div')({
    zIndex: '10',
    position: 'relative',
    display: 'flex',
    width:'100%',
    height:'46px'
    });

const NextButtonWrapper = styled('div')({
    padding:'20px',
    paddingTop:'16px',
    background: 'white',
    position: 'fixed',
    bottom:0,
    width: '100%'
})

export type PromoResultType = 'home' | 'edit' | 'modify' | 'detail' | 'editInterest' | 'modifyInterest'

const PromoResultPage = () => {
    const [tab, setTab] = useState<PromoResultType>('home');
    const setNavField = useNavbarStore((state)=>state.setField)
    const reset = useDialogStore((state)=>state.reset)
    const setField = useDialogStore((state)=>state.setField)
    const current_promo = usePromoresultStore((state)=>state.current_promotion)
    const setCustomAction = useBackHandlerStore((state)=>state.setCustomAction)
      useEffect(()=>{
        // 뒤로가기 대신 이 액션을 실행함!
        if(tab !== 'home'){
          setCustomAction(()=>{
                setTab('home');
                })
            }
        else{
          setCustomAction('')
        }
      },[tab])

    useEffect(()=>{
        if(tab === 'edit' || tab === 'modify' || tab === 'detail' || tab ==='editInterest' || tab ==='modifyInterest'){
            setNavField('isvisible',false)
        }
        return()=>{
            setNavField('isvisible',true)
        }
    },[tab])

    useEffect(()=>{
        return()=>{
            reset(false)
        }
    },[])

    const setTabEdit = () => {
        setNavField('isvisible',false)
        setTab('edit')
    }


const handleSubmit = async () => {
  await submitPromoFilter(false);
};
  return (
    <>
    {tab === 'home' &&
        <>
        <SearchContainer>
            <SearchBox>
                <InputBoxSearch placeholder='검색' onChange={(e)=>setField('school_name',e.target.value)} onClick={handleSubmit}/>
            </SearchBox>
            <div style={{width:'100%', overflowX:'auto'}} className='hide-scrollbar'>
                <FilterBar/>
            </div>
        </SearchContainer>
        <div style={{padding:'0px 20px', backgroundColor:'#F4F4F4', height:'calc(100% - 189px)'}}>
            <PromoResults setTab={setTab}/>
        </div>
        <PromoResultDialog />
        <NextButtonWrapper>
            <NextButton onClick={()=>setTabEdit()} style={{zIndex:3}}>홍보 결과 추가</NextButton>
        </NextButtonWrapper>
        </>
        }
    {tab === 'edit' &&
    <>
        <PromoResultAdd setTab={setTab}/>
    </>
    }
    {tab === 'modify' &&
    <>
        <PromoResultModify setTab={setTab} currentPromotion={current_promo}/>
    </>
    }
    {tab === 'detail' &&
    <>
        <PromoResultDetail setTab={setTab} currentPromotion={current_promo}/>
    </>
    }
    {tab === 'editInterest' &&
    <>
        <InterestedAdd setTab={setTab} currentPromotion={current_promo}/>
    </>
    }
    {
        tab === 'modifyInterest' &&
        <>
        <PromoInterstedModify setTab={setTab} currentPromotion={current_promo}/>
        </>
    }
    </>
  )
}

export default PromoResultPage